import { fetchUserClients } from '@app/services/clientService'
import { availableClients, clientNameAtom } from '@app/state/clientsAtom'
import { useQuery } from '@tanstack/react-query'
import { useAtomValue, useSetAtom } from 'jotai'
import { useEffect } from 'react'

export const useAvailableClients = () => {
  const setClients = useSetAtom(availableClients)
  const clientName = useAtomValue(clientNameAtom)

  const {
    data: clients,
    isLoading: isClientsLoading,
    error: clientsError,
    isError: isClientsError,
  } = useQuery({
    queryKey: ['clientList'],
    queryFn: () => fetchUserClients(),
    enabled: Boolean(clientName),
  })

  useEffect(() => {
    if (clients) setClients(clients)
  }, [clients, setClients])

  return { clients, isClientsLoading, isClientsError, clientsError }
}
